import * as yup from 'yup';
import { TrustPilot } from '@web/components';

export const component = TrustPilot;

export const schema = yup.object({
  header: yup.string().required(),
  level: yup.string(),
});
